/**
 *
 * NetworthBox1
 *
 */
import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { Assets, Debt, Networth_Image } from 'constants/constants';

import { useNetworth } from 'app/Provider/NetworthProvider';
import { media } from 'styles/media';
import Select from 'react-select';
import { formatCurrency } from 'utils/currency';
import { useDispatch, useSelector } from 'react-redux';
import { useGetNetworthSlice } from 'app/pages/Networth/slice';
import { selectGetNetworth } from 'app/pages/Networth/slice/selectors';
import { getPerformanceSummary } from 'utils/performanceSummary';

type OptionType = {
  value: string;
  label: string;
};
interface Props {}
const options = [
  { value: 'today', label: 'Today' },
  { value: '1month', label: '1 Month' },
  { value: '3months', label: '3 Months' },
  { value: '1year', label: '1 Year' },
  { value: '3years', label: '3 Years' },
];

export const NetworthBox1 = memo((props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const { actions } = useGetNetworthSlice();
  const dispatch = useDispatch();
  const [selected, setSelected] = useState<OptionType>(options[0]);
  const { data } = useNetworth();
  const [performance, setPerformance] = useState<any>({});

  //fetch based on selection
  const handleChange = (option: any) => {
    dispatch(actions.networthGrowth(option.value));
    setSelected(option);
  };
  const { getNetworthProgressSuccess } = useSelector(selectGetNetworth);
  //initially fetch for today
  useEffect(() => {
    dispatch(actions.networthGrowth('today'));
  }, [actions, dispatch]);

  useEffect(() => {
    if (getNetworthProgressSuccess) {
      setPerformance(getPerformanceSummary(getNetworthProgressSuccess));
      dispatch(actions.networthGrowthReset());
    }
  }, [getNetworthProgressSuccess, dispatch, actions]);

  return (
    <Maincontainer className="border ">
      <div className="d-flex justify-content-between py-2 px-3   align-items-center border-bottom">
        <BoldHeadingMedium className="my-1">Networth</BoldHeadingMedium>
        <img src={Networth_Image} alt="" />
      </div>
      <div className=" d-flex justify-content-center flex-column align-items-center mx-3">
        <div className="d-flex  align-items-center position-relative w-100  border-bottom ">
          <Arrowdiv>
            <hr className="my-5"></hr>
            {/* <Arrow className="bi bi-arrow-right position-absolute "></Arrow> */}
          </Arrowdiv>

          <FirstImage className="d-flex gap-2">
            <img src={Debt} alt="not found" />{' '}
            <span style={{ fontWeight: '500', fontSize: '16px' }}>Debt</span>
          </FirstImage>
          <SecondImage className="d-flex gap-2">
            <img src={Assets} alt="not found" />{' '}
            <span style={{ fontWeight: '500', fontSize: '16px' }}>Assets</span>
          </SecondImage>
          <div className="d-flex flex-column align-items-end justify-content-end h-100 w-100">
            <div
              className={`${
                !data.total_networth ? 'opacity-25' : 'opacity-100'
              }`}
              style={{
                fontWeight: '500',
                fontSize: '28px',
              }}
            >
              ₹ {formatCurrency(data.total_networth)}
            </div>
            <Assettext
              className={` me-2   ${
                !data.total_networth ? 'opacity-25 ' : 'opacity-100'
              }`}
            >
              ₹ {formatCurrency(data.assets_worth)}
            </Assettext>
            <Assettext
              className={`text-end me-2  mt-3 ${
                !data.total_networth ? 'opacity-25' : 'opacity-100'
              }`}
            >
              ₹ {formatCurrency(data.liabilities_worth)}
            </Assettext>
          </div>
        </div>
        <Wrapper className="p-1  d-flex justify-content-between  w-100">
          <Select
            options={options}
            styles={Selectstyles}
            onChange={handleChange}
            value={selected}
            components={{ IndicatorSeparator: () => null }}
          />
          <div className="d-flex align-items-center gap-2 ">
            <InnerFirstBox
              className={`d-flex align-items-center justify-content-center p-2    ${
                data.total_networth
              }?opacity-25:opacity-100 ${!data.total_networth} `}
              profit={performance?.isProfit}
            >
              {performance?.percentage}%
            </InnerFirstBox>
            <InnerSecondBox
              className={`d-flex align-items-center justify-content-center ${
                !data.total_networth ? 'opacity-25 text-dark ' : 'opacity-100'
              }`}
              profit={performance?.isProfit}
            >
              <span>
                {' '}
                (₹ {performance?.isProfit ? '' : '-'}
                {formatCurrency(performance?.amount)})
              </span>
            </InnerSecondBox>
          </div>
        </Wrapper>
      </div>
    </Maincontainer>
  );
});
const Assettext = styled.div`
  font-weight: 600;
  font-size: 16px;
`;

const BoldHeadingMedium = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #22283a;
`;
const Arrowdiv = styled.div`
  height: 6rem;
  width: 18px;
  margin-top: 8%;
  margin-bottom: 6%;
  border: 1.4px solid #c8ccd8;
  border-right: 1.5px solid white;
  border-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  position: relative;
`;
const FirstImage = styled.div`
  position: absolute;
  top: 70%;
  left: 30px;
`;
const SecondImage = styled.div`
  position: absolute;
  top: 43%;
  left: 30px;
`;
const Wrapper = styled.div`
  margin-top: 3%;
`;

const InnerSecondBox = styled.div<{ profit: boolean }>`
  height: 100%;
  font-weight: 600;
  color: ${props => (props.profit ? '#5dd3e1' : '#FF9B91')};
  border-radius: 5px;
`;
const InnerFirstBox = styled.div`
  background-color: #eafcff;

  height: 50%;
  font-weight: 800;
  color: #5dd3e1;
  border-radius: 5px;
`;
const Maincontainer = styled.div`
  width: 25vw;
  height: auto;
  border-radius: 20px;
  background-color: #ffffff;
  ${media.medium} {
    height: auto;
    width: 70vw;
  }
  ${media.small} {
    width: 350px;
    height: auto;
  }
`;
const Selectstyles = {
  control: (base, state) => ({
    ...base,
    paddingLeft: '0%',
    fontSize: '1rem',
    border: '1.2px solid #e8e5f9',
    outline: 'none',
    width: '150px',
    boxShadow: 'none',
    borderRadius: '10px',
    backgroundColor: '#FFFFF',
    height: '46px',
    gap: '15px',
    alignItems: 'center',
    '&:focus': {
      borderColor: '#FFFFF',
    },
    '&:hover': {
      borderColor: '#FFFFF',
    },
  }),
  container: base => ({
    ...base,
    width: '100%',
    flex: 1,
  }),
  input: base => ({
    ...base,
    margin: 0,
    padding: 0,
    fontWeight: '400',
    fontSize: '14px',
    width: '100%',
  }),
  placeholder: base => ({
    ...base,
    fontSize: '14px',
    fontWeight: 300,
  }),
  singleValue: base => ({
    ...base,
    fontSize: '1rem',
    width: '100%',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#E6E6FA'
      : state.isFocused
      ? '#F8F7FF'
      : 'white',
    color: '#333',
    padding: '8px 16px',
    borderBottom: '1px solid #E4DFFF',
    '&:active': {
      backgroundColor: '#E6E6FA',
    },
  }),
  menu: base => ({
    ...base,
    borderRadius: '16px',
    overflowY: 'auto',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    width: '90%',
    scrollbarWidth: 'thin',
    scrollbarColor: '#8276F4 #E4DFFF',
    '&::-webkit-scrollbar': {
      width: '3px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#E4DFFF',
      borderRadius: '4px',
      margin: '8px 0',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#8276F4',
      borderRadius: '4px',
      width: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#6B5FED',
    },
  }),
  menuList: base => ({
    ...base,
    padding: '8px 0',
  }),
};
